import { call, put, takeEvery } from "redux-saga/effects"
import { toast } from "react-toastify";
import { CREATE_ADD_HOME_PREF, CREATE_BUY_DESTINATION, CREATE_HOME_DESTINATION, CREATE_IMP_DESTINATION, DELETE_HOME_DESTINATION, DELETE_IMP_DESTINATION, GET_ADD_HOME_PREF, GET_BUY_PREFRENCES_QUEST, GET_HOME_DESTINATION, GET_IMP_DESTINATION, UPDATE_ADD_HOME_PREF, UPDATE_HOME_DESTINATION, UPDATE_IMP_DESTINATION } from "./actionTypes"
import { deleteAddHomePrefUrl, deleteImpDestUrl, getAddHomePrefUrl, getClientPrefQuestAPI, getHomePrefUrl, getImpDestUrl, postAddHomePrefUrl, postBuyerDestinationUrl, postHomePrefUrl, postImpDestUrl, updateAddHomePrefUrl, updateHomePrefUrl, updateImpDestUrl } from '../../helpers/backend_helper'
import { createAddHomePrefFail, deleteImpDestinationFail, deleteImpDestinationSuccess, getAddHomePrefFail, getAddHomePrefSuccess, getClientPrefrencesQuestFail, getClientPrefrencesQuestSuccess, getHomePrefFail, getHomePrefSuccess, getImpDestinationFail, getImpDestinationSuccess, postBuyerDestinationFail, postBuyerDestinationSuccess, postHomePrefFail, postHomePrefSuccess, postImpDestinationFail, updateAddHomePrefFail, updateHomePref, updateHomePrefFail, updateHomePrefSuccess, updateImpDestinationFail } from "./actions"

function* fetchClientPrefQuest({ forType }) {
  try {
    const response = yield call(getClientPrefQuestAPI, forType)
    yield put(getClientPrefrencesQuestSuccess(response))
  } catch (error) {
    yield put(getClientPrefrencesQuestFail(error))
  }
}

function* submitBuyerDestination({ payload: { destination, history } }) {
  try {
    //console.log(destination);
    toast.loading("Please wait...")
    const response = yield call(postBuyerDestinationUrl, {
      destinationTitle: destination.destinationTitle,
      destinationAddress: destination.destinationAddressss ,
      isValid:true,
      clientId: 5,
      agentId: 4,
      
    })
    yield put(postBuyerDestinationSuccess(response))
  }
  catch (error) {

    yield put(postBuyerDestinationFail(error))
  }
}

function* submitHomePref({ payload: { homepref, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");
    const response = yield call(postHomePrefUrl, homepref);
    if (response?.success) {
      toast.update(toastId, {
        render: "Saved successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      const res = yield call(getHomePrefUrl, homepref.clientGuid);
      yield put(postHomePrefSuccess(res));

      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response?.error?.validationErrors[0] || "Some error. Please try again later",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });

      if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: error.response?.data?.message || "An error occurred",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });

    yield put(postHomePrefFail(error));

    if (callback) callback(false, error);
  }
}


function* fetchHomePref({ ClientId }) {
  // console.log(ClientId);
   try {
     const response = yield call(getHomePrefUrl, ClientId)
     yield put(getHomePrefSuccess(response))
   } catch (error) {
     yield put(getHomePrefFail(error))
   }
 }


function* onUpdateHomePref({ payload: { homepref, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");

    const response = yield call(updateHomePrefUrl, homepref);

    if (response?.success) {
      toast.update(toastId, {
        render: "Updated successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      const res = yield call(getHomePrefUrl, homepref.clientGuid);
      yield put(getHomePrefSuccess(res));

      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response?.error?.validationErrors[0] || "Failed to update preferences",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });

      if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: error.response?.data?.message || "An error occurred",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });

    yield put(updateHomePrefFail(error));
    if (callback) callback(false);
  }
}



function* submitImpDest({ payload: { impdes, callback } }) {
  try {
    toast.loading("Please wait...");
    
    const response = yield call(postImpDestUrl, impdes);
    
    toast.dismiss(); // Remove loading indicator

    if (response.success === true) {
      toast.success("Important Destination Added");
      const res = yield call(getImpDestUrl, parseInt(impdes.clientId), impdes.agentId);
      yield put(getImpDestinationSuccess(res))
      if(callback){
        callback(true);
      }
    } else {
      const errorMessage = response.validationErrors?.length 
        ? response.validationErrors.join(", ") 
        : "Some error occurred. Please try again later.";

      toast.warn(errorMessage);
      if(callback){
        callback(false);
      }
    }
  } catch (error) {
    toast.dismiss();
    const errorMsg = error.response?.data?.message || "Failed to add destination. Please try again.";
    toast.error(errorMsg);
    yield put(postImpDestinationFail(error));
    if(callback){
        callback(false);
      }
  }
}



function* fetchImpDestination({ payload: { clientId, agentId } }) {
  try {
    const response = yield call(getImpDestUrl, clientId, agentId )
    yield put(getImpDestinationSuccess(response))
  } catch (error) {
    yield put(getImpDestinationFail(error))
  }
}


function* submitAddHomePref({ payload: { addpref, history } }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(postAddHomePrefUrl,addpref)
    if (response.success == true) {
      toast.dismiss();
      toast.success("Home Preferences Added");
      const agentId = localStorage.getItem('agentId');
      const res = yield call(getAddHomePrefUrl, addpref.clientGuid, agentId)
      yield put(getAddHomePrefSuccess(res))
    } else {
       toast.dismiss();
      toast.warn(response.validationErrors[0] || 'some issue please try after some time');
    }
  }
  catch (error) {

    yield put(createAddHomePrefFail(error))
  }
}

function* fetchAddHomePref({ clientId }) {
   try {
    const agentId = localStorage.getItem('agentId');
     const response = yield call(getAddHomePrefUrl, clientId, agentId)
     yield put(getAddHomePrefSuccess(response))
   } catch (error) {
     yield put(getAddHomePrefFail(error))
   }
 }

 function* onUpdateAddHomePref({ payload: addpref }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(updateAddHomePrefUrl, addpref)
    toast.dismiss();
    toast.success("Home Prefrences Updated");
     const agentId = localStorage.getItem('agentId');
    const res = yield call(getAddHomePrefUrl, addpref.clientGuid, agentId)
    yield put(getAddHomePrefSuccess(res))


  } catch (error) {
    yield put(updateAddHomePrefFail(error))
  }
}


function* onUpdateImportantDest({ payload: importantDes }) {
  try {
    
    toast.loading("Please wait...")
    const response = yield call(updateImpDestUrl, importantDes)
    toast.dismiss();
    toast.success("Important Destination Updated");
    const res = yield call(getImpDestUrl, importantDes.clientId, importantDes.agentId)
    yield put(getImpDestinationSuccess(res))


  } catch (error) {
    yield put(updateImpDestinationFail(error))
  }
}

function* onDeleteImp({ payload: impdestination }) {
  console.log(impdestination);
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteImpDestUrl, impdestination.id)
    yield put(deleteImpDestinationSuccess(response))
    toast.dismiss();
    toast.success("Important Destination Deleted");
    const res = yield call(getImpDestUrl, impdestination.clientId, impdestination.agentId)
    yield put(getImpDestinationSuccess(res))

  } catch (error) {
    yield put(deleteImpDestinationFail(error))
  }
}

function* onDeletePref({ payload: pref }) {
  
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteAddHomePrefUrl, pref.clientAdditionalHomePreferenceId)
    yield put(getHomePrefSuccess(response))
    toast.dismiss();
    toast.success("Prefrences Deleted");
     const agentId = localStorage.getItem('agentId');
   const res = yield call(getAddHomePrefUrl, pref.clientGuid, agentId)
    yield put(getImpDestinationSuccess(res))

  } catch (error) {
    yield put(getAddHomePrefSuccess(error))
  }
}

function* prefrencesSaga() {
  yield takeEvery(GET_BUY_PREFRENCES_QUEST, fetchClientPrefQuest)
  yield takeEvery(CREATE_BUY_DESTINATION, submitBuyerDestination)
  yield takeEvery(CREATE_HOME_DESTINATION, submitHomePref)
  yield takeEvery(GET_HOME_DESTINATION, fetchHomePref)
  yield takeEvery(UPDATE_HOME_DESTINATION, onUpdateHomePref)
  yield takeEvery(CREATE_IMP_DESTINATION, submitImpDest)
  yield takeEvery(GET_IMP_DESTINATION, fetchImpDestination)
  yield takeEvery(CREATE_ADD_HOME_PREF, submitAddHomePref)
  yield takeEvery(GET_ADD_HOME_PREF, fetchAddHomePref)
  yield takeEvery(UPDATE_ADD_HOME_PREF, onUpdateAddHomePref)
  yield takeEvery(UPDATE_IMP_DESTINATION, onUpdateImportantDest)
  yield takeEvery(DELETE_IMP_DESTINATION, onDeleteImp)
   yield takeEvery(DELETE_HOME_DESTINATION, onDeletePref)

}


export default prefrencesSaga
